import { useState } from "react";
import { useTranslation } from "react-i18next";

// The quotes live in the locale files, so they are shown in the user's language
const QUOTES_KEY = "quotes.items";

export default function RandomQuote() {
  const { t } = useTranslation();
  const quotes = t(QUOTES_KEY, { returnObjects: true });
  const count = Array.isArray(quotes) ? quotes.length : 0;
  // Pick the quote once, so it stays the same when the language changes
  const [index] = useState(() => Math.floor(Math.random() * count));

  const quote = count > 0 ? quotes[index % count] : null;
  if (!quote) return null;

  return (
    <div
      style={{
        marginTop: "2rem",
        fontStyle: "italic",
        textAlign: "center",
        color: "white",
      }}
    >
      <p>"{quote.quote}"</p>
      <p style={{ fontWeight: "bold", marginTop: "0.5rem" }}>
        — {quote.author}
      </p>
    </div>
  );
}
